import a from "styled-components";
import { Base as c, Button as g } from "./atoms-v2777.js";
import { getStyles as d, getSize as p } from "./atoms-v2785.js";
import { Variants as u } from "./atoms-v2786.js";
const S = a.button`
  ${c}
  ${g}

  /* Load the appropriate styles based on several props. */
  ${({ $colorTheme: t, $isIconOnly: o, $isSkeleton: n, $isTextOnly: i, $shape: r, $size: s, $variant: e, theme: l }) => d({
  colorTheme: t,
  isIconOnly: o,
  isSkeleton: n,
  isTextOnly: i,
  shape: r,
  size: s,
  theme: l,
  variant: e
})}

  ${({ $isSkeleton: t, $size: o, $variant: n, theme: i }) => p({
  isSkeleton: t,
  size: o,
  theme: i,
  variant: n
})}

  align-items: center;
  cursor: ${({ disabled: t }) => t ? "auto" : "pointer"};
  display: ${({ $variant: t }) => t === u.text ? "inline-flex" : "flex"};
  justify-content: center;
  min-width: ${({ $isIconOnly: t, $isSkeleton: o }) => o && !t ? "100px" : "auto"};
  transition:
    background-color ${({ theme: t }) => t == null ? void 0 : t.get("tokens.motion").toString("duration.fast")}
      ${({ theme: t }) => t == null ? void 0 : t.get("tokens.motion").toString("easing.standard")},
    color ${({ theme: t }) => t == null ? void 0 : t.get("tokens.motion").toString("duration.fast")}
      ${({ theme: t }) => t == null ? void 0 : t.get("tokens.motion").toString("easing.standard")},
    outline ${({ theme: t }) => t == null ? void 0 : t.get("tokens.motion").toString("duration.fast")}
      ${({ theme: t }) => t == null ? void 0 : t.get("tokens.motion").toString("easing.standard")};
  width: ${({ $display: t }) => t === "block" ? "100%" : "auto"};
`, x = a.div`
  align-items: center;
  column-gap: 6px;
  display: flex;

  /**
   * Typically icons will share a baseline with sibling text, but in a Button they are
   * vertically-centered. The Icon component includes a transform to adjust its vertical position,
   * accounting for a built-in “safe zone”. To center vertically hyphenate-character, we need to
   * remove that transform on all i elements.
   */
  & > i {
    transform: none;
  }
`;
export {
  S as Button,
  x as Content
};
